import $ from "jquery";
import "slick-carousel";
import "../assets/arrow-right.svg";

$(function () {
  $(".slider").slick({
    autoplay: false,
    arrows: false,
    fade: true,
    asNavFor: ".thumbnail",
  });
  $(".thumbnail").slick({
    slidesToShow: 5,
    asNavFor: ".slider",
    focusOnSelect: true,
    infinite: false,
  });
});
